import React, { useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import classNames from 'classnames';
import Icon, { COLORS, ICONS } from './general-components/icon';
import StylePackItem from './style-packs/style-pack-item';
import { StylePackItemTypes } from './style-packs/style-packs-tab';

export interface CarouselProps {
    id: string;
	renderItem?: (item: any, index: number) => JSX.Element;
    list: any[];
    onClick?: (item: any, index: number) => void;
    itemWidth?: number;
	drawerOpening?: boolean;
}

export default function Carousel(props: CarouselProps) {
	const {
		id,
		list = [],
		onClick,
		itemWidth = 134,
		drawerOpening = false,
	} = props;

	const [position, setPosition] = useState(0);

	function scrollCarousel(page: number) {
		if (page < 0) {
			page = list.length - 2;
		} else if (page >= list.length - 1) {
			page = 0;
		}

		setPosition(page);

		const container = document.getElementById(id);
		if (container) {
			container.scrollTo({ left: page * itemWidth, behavior: 'smooth' });
		}
	}

	return (
		<div className='carousel'>
			<div
				className="carousel-track"
				data-testid="carousel"
				id={id}

				onWheel={(e) => {
					if (e.deltaY > 0 && position < list.length - 2) {
						scrollCarousel(position + 1);
					} else if (position > 0 && e.deltaY < 0) {
						scrollCarousel(position - 1);
					}
				}}
			>
				{list.map((item, index) => (
					<div
						className="carousel-item"
						data-testid={`carousel-item-${index}`}
						key={index}
						onClick={() => onClick?.(item, index)}
					>
						{drawerOpening
							? <Skeleton width={135} height={72} style={{
								marginRight: '8px',
								borderRadius: '8px',
							}}/>
							: <StylePackItem
								key={`style-pack-carousel-item-${item.id}`}
								item={item}
								type={StylePackItemTypes.Carousel}
							/>
						}
					</div>
				))}

			</div>
			<div
				className={`carousel-gradient left ${(position > 0 && list.length > 2) ? 'visible' : ''}`}
				data-testid="carousel-left-gradient"
			/>
			<div
				className={classNames('carousel-gradient right', {
					visible: drawerOpening || (position < list.length - 2 && list.length > 2),
				})}
				data-testid="carousel-right-gradient"
			/>
			<div
				className={`carousel-arrow left ${(position > 0 && list.length > 2) ? 'visible' : ''}`}
				data-testid="carousel-arrow carousel-left-arrow"
				onClick={() => {
					if ((position > 0 && list.length > 2)) {
						scrollCarousel(position - 1);
					} else {
						onClick?.(list[0], 0);
					}
				}}
			>
				<Icon
					name={ICONS.KEYBOARD_ARROW_LEFT}
					color={COLORS.BLACK}
					size={12}
				/>
			</div>
			<div
				className={classNames('carousel-arrow right', {
					visible: !drawerOpening && (position < list.length - 2 && list.length > 2),
				})}
				data-testid="carousel-arrow carousel-right-arrow"
				onClick={() => {
					if ((position < list.length - 2 && list.length > 2)) {
						scrollCarousel(position + 1);
					} else {
						onClick?.(list[list.length - 1], list.length - 1);
					}
				}}
			>
				<Icon
					name={ICONS.KEYBOARD_ARROW_RIGHT}
					color={COLORS.BLACK}
					size={12}
				/>
			</div>
		</div>
	);
}
